import { Component, Inject, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import interactiveScenariosTemplate from './interactive-scenarios-banner.html';

@Component({
    selector: 'interactive-scenarios-banner',
    template: interactiveScenariosTemplate
})
export class InteractiveScenariosBannerComponent {
    showInteractiveScenariosBanner:boolean = true;    

    constructor(@Inject(CookieService) private cookies: CookieService) {
    }

    ngOnInit() {
        var trialBannerCookie = this.cookies.get("ExpertOrAboveBanner");
        if (trialBannerCookie == "true") {
            this.showInteractiveScenariosBanner = true;
        } else {
            this.showInteractiveScenariosBanner = false;
        }
    }

    bannerClose() {
        const cookieOptions = {
            path: "/",
            secure: false
        };
        this.showInteractiveScenariosBanner = false;
        this.cookies.set("ExpertOrAboveBanner", "false", cookieOptions);
    }
}
